import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import CurrencyAmountInput from "../../NewSales/components/CurrencyAmountInput";

export const PaymentModal = ({
	t,
	show,
	onHide,
	paymentData,
	onPaymentDataChange,
	errors,
	handleSave,
	disableScrollProps,
	totals,
	getCurrencySymbol,
	defaultCurrency,
	convertCurrency
}) => (
	<Modal show={show} onHide={onHide} centered>
		<Modal.Header closeButton style={{ backgroundColor: "#f8d7da", borderColor: "#f5c6cb" }}>
			<Modal.Title style={{ color: "#721c24" }}>
				<i className="fa fa-undo me-2" />
				{t("Process Return")}
			</Modal.Title>
		</Modal.Header>
		<Modal.Body>
			<Form>
				<Form.Group className="mb-3">
					<Form.Label>{t("Payment Type")}</Form.Label>
					<Form.Select
						value={paymentData.type}
						onChange={(event) => onPaymentDataChange({ type: event.target.value })}
						isInvalid={!!errors.type}
					>
						<option value="cash">{t("Cash")}</option>
						<option value="card">{t("Card")}</option>
						<option value="upi">{t("UPI")}</option>
					</Form.Select>
					<Form.Control.Feedback type="invalid">{errors.type}</Form.Control.Feedback>
				</Form.Group>
				{/* <Form.Group className="mb-3">
					<Form.Label>{t("Amount")}</Form.Label>
					<Form.Control
						type="number"
						value={paymentData.amount}
						onChange={(event) => onPaymentDataChange({ amount: event.target.value })}
						isInvalid={!!errors.amount}
						{...disableScrollProps}
					/>
					<Form.Control.Feedback type="invalid">{errors.amount}</Form.Control.Feedback>
				</Form.Group> */}
				<CurrencyAmountInput
					label={t("Return Amount")}
					amount={paymentData.amount}
					onAmountChange={(value) => onPaymentDataChange({ amount: value })}
					onCurrencyChange={(cur) => onPaymentDataChange({ currency: cur })}
					disabled={true}
					errors={errors}
					disableScrollProps={disableScrollProps}
					defaultCurrency={defaultCurrency}
					originalAmount={totals.netTotal}
				/>
				<Form.Group>
					<Form.Label>{t("Reason")}</Form.Label>
					<Form.Control
						as="textarea"
						rows={2}
						value={paymentData.reason}
						onChange={(event) => onPaymentDataChange({ reason: event.target.value })}
					// isInvalid={!!errors.reason}
					/>
					{/* <Form.Control.Feedback type="invalid">{errors.reason}</Form.Control.Feedback> */}
				</Form.Group>
			</Form>
			<div className="p-2 mt-3 d-flex justify-content-end flex-column payment-info bg-primary-subtle">
				<p className="mb-0">
					<strong>{t("Return Amount")}:</strong> {getCurrencySymbol(paymentData.currency)}
					{convertCurrency(totals.netTotal, defaultCurrency, paymentData.currency).toFixed(2)}
				</p>
			</div>
		</Modal.Body>
		<Modal.Footer>
			<Button variant="primary" onClick={handleSave}>
				{t("Submit Return")}
			</Button>
			<Button variant="secondary" onClick={onHide}>
				{t("Cancel")}
			</Button>
		</Modal.Footer>
	</Modal>
);

export default PaymentModal;





